/**
 * API формы подключения «Собственной»: виды цен ресурса для подсказки в форме.
 * Только чтение; данные кэшируются по ресурсу.
 */
import { baseApi, resourceScopeTag } from '@krp/client-runtime'

import { decodePriceTypes, type OwnPriceType } from './contracts'
import { OWN_URLS } from './urls'

export interface OwnResourceArgs {
  resourceId: string
}

export const ownConnectionApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    /** Виды цен для подсказки в форме: читаются только у уже созданного ресурса (право `session.open` на нём). */
    ownPriceTypes: build.query<readonly OwnPriceType[], OwnResourceArgs>({
      query: ({ resourceId }) => ({ url: OWN_URLS.priceTypes(), params: { resourceId }, decode: decodePriceTypes }),
      providesTags: (_result, _error, { resourceId }) => [resourceScopeTag(resourceId)],
    }),
  }),
})

export const { ownPriceTypes } = ownConnectionApi.endpoints
